import React, { useEffect, useRef } from 'react';
import style from './compass.module.scss';

interface CompassProps {
  rotation: number;
}

const Compass: React.FC<CompassProps> = ({ rotation }) => {
  // Initialize refs with Math.PI to point north by default
  const prevRotationRef = useRef(Math.PI);
  const accumulatedRotationRef = useRef(Math.PI);

  useEffect(() => {
    // Calculate the shortest path for rotation
    let delta = rotation - prevRotationRef.current;

    // Normalize delta to be between -PI and PI
    if (delta > Math.PI) {
      delta -= 2 * Math.PI;
    } else if (delta < -Math.PI) {
      delta += 2 * Math.PI;
    }

    // Smoothly accumulate the rotation
    accumulatedRotationRef.current += delta;
    prevRotationRef.current = rotation;
  }, [rotation]);

  // Convert to degrees for CSS transform and add 180 degrees to match camera orientation
  const rotationDegrees =
    (accumulatedRotationRef.current * 180) / Math.PI + 180;

  return (
    <div className={style.compass} data-testid="compass">
      {/* Static background and directions */}
      <div className={style.compassBackground} />

      {/* Static cardinal directions */}
      <div className={style.north}>N</div>
      <div className={style.south}>S</div>
      <div className={style.west}>W</div>
      <div className={style.east}>E</div>

      {/* Rotating arrow */}
      <div
        className={style.arrowContainer}
        style={{ transform: `rotate(${rotationDegrees}deg)` }}
      >
        <div className={style.arrow} />
      </div>
    </div>
  );
};

export default Compass;
